import { render, staticRenderFns } from "./parallel.vue?vue&type=template&id=42d93976&scoped=true&lang=pug&"
import script from "./parallel.vue?vue&type=script&lang=ts&"
export * from "./parallel.vue?vue&type=script&lang=ts&"
import style0 from "./parallel.vue?vue&type=style&index=0&id=42d93976&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d93976",
  null
  
)

export default component.exports